import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePortal } from "@/react/Providers/PortalProvider";
import { getClientType } from "@/react/utils";
import useRoutes from "@/react/Webshop/hooks/useRoutes";
// Reuses the desktop banner's msgids (NetlifeConsentProvider.php), so the
// %s pairs mark the link texts and no new strings go to Crowdin.
const CookieConsentDescription = ({ onNavigate, }) => {
    const [t] = useTranslation();
    const portal = usePortal();
    const routes = useRoutes();
    const isMobile = getClientType() === "mobilev2";
    const links = [routes.cookiesdescription.path, routes.privacypolicy.path];
    const text = portal.webshop.hasPrivacyPolicy
        ? t("By continuing to use our website you are agreeing to our use of %sCookies%s and to our %sPrivacy Policy%s")
        : t("By continuing to use our website you are agreeing to our use of %sCookies%s");
    return (React.createElement(React.Fragment, null, text.split("%s").map((part, index) => {
        const href = index % 2 === 1 ? links[(index - 1) / 2] : undefined;
        if (!href) {
            return React.createElement(React.Fragment, { key: index }, part);
        }
        return isMobile ? (React.createElement(Link, { key: index, to: href, onClick: onNavigate }, part)) : (React.createElement("a", { key: index, href: href, onClick: onNavigate }, part));
    })));
};
export default CookieConsentDescription;
